/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { ProgressBar } from '../ProgressBar';
import { Error, Span, Star } from './styles';
import { ItemSpecVenusWidget } from '../../../../widgets/item-spec-venus-widget-react';
import { toCamelCase, toUpperCase } from 'js-convert-case';
import { toUpper } from 'lodash';
import { IHeaderCompProps, RightContainer } from '../RightContainer';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { ChannelPage } from '@/widgets/channel-page-widget-react';
import { OrganisationProfilePageService } from '../../services';
import { vappContainer } from '@/application';
import { FontSlider } from '../FontSlider';

const getSrv = () => {
  return vappContainer.get<OrganisationProfilePageService>(
    OrganisationProfilePageService.displayName
  );
};
import * as S from './styles';
import { AppNavigatorService } from '@/AppNavigator';
import axios from 'axios';
interface IFormData {
  fields: any[];
  newFields: any[];
  spinner: any;
  successIcon: any;
  errorIcon: any;
  selectFormFields: any[];
  existingFields: any[];
  existingLayout: any[];
  selectFormLayout: any[];
  confirmField: any[];
  newLayout: any[];
  validatorConfig?: any;
  dynamicLayout?: any[];
  previewLabel?: string;
  progressBarSteps?: string[];
}

export const FormCompp = ({
  formData,
  stepChange,
  spinner,
  parish,
  //setParish,
  onAcknowledgement,
  touchedStatus,
  _changeCurrStep,
  currentStep,
  onGoBack,
  initialData,
  setInitialData,
  label,
  field,
  whoami,
  rightBlockContent,
  onNextClick,
  _changeTouchStatus,
  fontScale,
  updateFontScale,
  citydata,
}: {
  // stepChange:any;
  // currentStep: any;
  // spinner:any;
  // _changeCurrStep?(val:any):void;
  fontScale?: any;
  updateFontScale?: any;
  _changeTouchStatus?(val: any): void;
  touchedStatus?: any;
  parish?: any;
  //setParish?: any;
  initialData?: any;
  setInitialData?: any;
  whoami: String;
  label?: string;
  formData: IFormData;
  field?: any;
  onAcknowledgement?(payload: any): void;
  onGoBack?(): void;
  rightBlockContent?: any;
  onNextClick?(payload: anyy): void;
  citydata?: any;
}) => {
  const {
    fields,
    existingFields,
    confirmField,
    existingLayout,
    newFields,
    dynamicLayout,
    newLayout,
    successIcon,
    errorIcon,
    newLayout2,
    validatorConfig,
    previewLabel,
    selectFormFields,
    selectFormLayout,
    selectvalidatorConfig,
    relatedDocuments,
  } = formData;
  console.log('insideformcompp', relatedDocuments);
  const [formFields, setFormFields] = useState(fields);
  const fieldlen = fields.length;
  const [activeStep, setActiveStep] = useState(0);
  const [trnEnable, setTrnEnable] = useState(true);
  const [prevsteperr, setPrevStepErr] = useState({});
  // const [initialData, setinitialData] = useState({});
  const [selectForm, setselectForm] = useState('');
  const [layout, setlayout] = useState([]);
  const [dynamicKey, setDynamicKey] = useState('first');
  const [temp, setTemp] = useState(1);
  const [stepHasError, setStepHasError] = useState<any>({});
  const [tempKey, setTempKey] = useState(1);
  const [_touchedStatus, _setTouchedStatus] = useState({
    1: false,
    2: false,
    3: false,
  });
  const loginSrv = () => {
    return vappContainer.get<AppNavigatorService>(
      AppNavigatorService.displayName
    );
  };
  const changeDynamic = (step: any) => setDynamicKey(step);
  const documentsName = {
    BUSSINESS_REGISTRATION: 'businessRegistration',
    TAX_CLEARANCE_CERTIFICATE: 'taxClearanceCertificate',
    ARTICAL_OF_INCORPORATION: 'articleOfIncorporation',
    CERTIFICATE_OF_INCORPORATION: 'certificateOfIncorporation',
    ANNUAL_RETURN: 'annualReturn',
    IMMIGRATION_STATUS: 'immigrationStatus',
    CERTIFICATE_OF_GOOD_STANDING: 'certificateOfGoodStading',
    BANK_STATMENT: 'bankStatement',
    EXISTING_INVOICES: 'existingInvoices',
    LEASE_AGREEMENT: 'leaseOrRentalAgreement',
    COMPAY_OFFICE_OF_JAMAICA_RECEIPT: 'companyReceipt',
  };
  const availDocuments = {
    businessRegistration: 'BUSSINESS_REGISTRATION',
    taxClearanceCertificate: 'TAX_CLEARANCE_CERTIFICATE',
    articleOfIncorporation: 'ARTICAL_OF_INCORPORATION',
    certificateOfIncorporation: 'CERTIFICATE_OF_INCORPORATION',
    annualReturn: 'ANNUAL_RETURN',
    immigrationStatus: 'IMMIGRATION_STATUS',
    certificateOfGoodStading: 'CERTIFICATE_OF_GOOD_STANDING',
    bankStatement: 'BANK_STATMENT',
    existingInvoices: 'EXISTING_INVOICES',
    leaseOrRentalAgreement: 'LEASE_AGREEMENT',
    companyReceipt: 'COMPAY_OFFICE_OF_JAMAICA_RECEIPT',
  };
  // useEffect(() => {
  //   setTouched({ ...touchedStatus });
  // }, [touchedStatus]);
  useEffect(() => {
    console.log('stephaserr->', stepHasError);
  }, [stepHasError]);
  // useEffect(()=>console.log("ruetyierut-->",formFields,newLayout2[0]?.[dynamicKey]?.data,dynamicLayout))

  useEffect(() => {
    console.log('tempjram', temp, successIcon, errorIcon);
    if (temp == 1) changeDynamic('first');
    else if (temp == 2) changeDynamic('second');
    else if (temp == 3) changeDynamic('third');
  }, [temp]);
  // useEffect(() => console.log('jramminti', initialData));
  // console.log('initialData2', initialData);
  const fetchcl = async (src: any) => {
    const token = loginSrv()?.getToken();
    try {
      const response = await axios.get(src, {
        headers: {
          'Content-Type': 'application/json',
          Authentication: `${token}`,
        },
        responseType: 'arraybuffer',
      });

      const data = response.data;

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(new Blob([data]));
        reader.onload = () => {
          const res = reader.result + '';
          console.log('final_initdata', res);
          resolve(res);
        };
        reader.onerror = (error) => reject(error);
      });
    } catch (error) {
      console.error('Error:', error);
      // Handle error
    }
  };
  const _getDocument = (payload: any) => {
    console.log('paylooads', payload);

    let _documents: any = {};
    availDocuments &&
      Object.entries(availDocuments).forEach((ele, index) => {
        let _similarDoc: any[] = [];
        payload &&
          Array.isArray(payload) &&
          payload.length > 0 &&
          payload.map(async (doc: any) => {
            if (doc?.type === ele[1]) {
              _similarDoc.push({
                name: doc?.name,
                src: await fetchcl(doc?.src),
                type: doc?.fileType,
              });
            }
          });
        _documents[ele[0]] = _similarDoc;
      });
    console.log('formatAppDraft getDocuments ', _documents);
    console.log('paylooads2', _documents);
    return _documents;
  };
  const _getCityOptions = (data: any[]) => {
    let _options: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: string, index: number) => {
        if (item) {
          _options.push({
            label: item,
            id: item,
          });
        }
      });

    return _options;
  };
  const getcity = (parish: any) => {
    return { cities: _getCityOptions(citydata?.[parish]) };
  };
  const formatData = (data: any) => {
    // console.log("hahahaata->",data);
    if (!data || !Array.isArray(data) || !data.length > 0) {
      return null;
    }
    return data?.map((ele) => {
      const lastNameExist =
        ele?.isLastNameExist === true
          ? 'yes'
          : ele?.isLastNameExist === false
          ? 'no'
          : '';
      let isLastNameExist = lastNameExist ?? null;
      return { ...ele?.address, ...ele, isLastNameExist, id: ele.email };
    });
  };

  useEffect(() => {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('myProfile', 'local');
    const _sessionData = storageService.get('myProfile', 'session');
    const userData = _sessionData ?? _localData;
    console.log('USANDATA', userData);
    let natureOfBusiness = userData?.org?.natureOfBusiness;
    const documents = _getDocument(userData?.org?.documents);
    // console.log('123213123', userData?org?.landlineContactNo);
    if (userData?.email && whoami !== 'prospective_employee') {
      setTrnEnable(userData?.org?.trn ? true : false);
      setInitialData({
        ...initialData,
        ...documents,
        email: userData?.org?.email,
        trn: userData?.org?.trn,
        name: userData?.org?.name,
        tccExpiryDate: userData?.org?.tccExpiryDate,
        tradingName: userData?.org?.tradingName,
        primaryContactNo: userData?.primaryContactNo,
        landlineContactNo: userData?.org?.landlineContactNo,
        isAddressSame: userData?.org?.isOperatingAddressSame ? 'yes' : 'no',
        companyEmail: userData?.org?.email,
        incorporationDate: userData?.org?.incorporationDate,
        type: userData?.org?.type,
        registrationNo: userData?.org?.registrationNo,
        businessRegistrationExpiryDate:
          userData?.org?.businessRegistrationExpiryDate,
        // isAddressSame:
        //   userData?.org?.address?.addressLine1 ===
        //   userData?.org?.operatingAddress?.addressLine1
        //     ? 'yes'
        //     : 'no',
        addressLine1: userData?.org?.address?.addressLine1,
        addressLine2: userData?.org?.address?.addressLine2,
        addressLine3: userData?.org?.address?.addressLine3,
        city: userData?.org?.address?.city,
        country: userData?.org?.address?.country,
        parish: userData?.org?.address?.parish,
        zipcode: userData?.org?.address?.zipcode,
        natureOfBusiness: natureOfBusiness,
        operatingaddressLine1: userData?.org?.operatingAddress?.addressLine1,
        operatingaddressLine2: userData?.org?.operatingAddress?.addressLine2,
        operatingCity: userData?.org?.operatingAddress?.city,
        operatingParish: userData?.org?.operatingAddress?.parish,
        operatingzipcode: userData?.org?.operatingAddress?.zipcode,
        website: userData?.org?.website,

        branches: formatData(userData?.org?.branches),
        directors: formatData(userData?.org?.directors),
        subsidiaries: formatData(userData?.org?.subsidiaries),
        // documents: formatData(userData?.org?.documents),
        //   isBranchExist
        // isDirectorExist
        // isSubsidiaryExist
        isAddDirector: userData?.org?.isDirectorExist ? 'yes' : 'no',
        // : null,
        isAddBranch: userData?.org?.isBranchExist ? 'yes' : 'no',
        // : null,
        isAddSubsidiary: userData?.org?.isSubsidiaryExist ? 'yes' : 'no',
        // : null,

        // bankStatement:userData?.org?.documents[0]?.src
      });
    }
  }, []);

  const onActiveStepChange = () => {
    if (activeStep === 0) {
      onGoBack && onGoBack();
    } else {
      setActiveStep(activeStep - 1);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);
  console.log(initialData);
  useEffect(() => {
    setTempKey(temp);
  }, [temp]);
  useEffect(() => {
    if (selectForm === 'new') {
      setFormFields([...fields, ...newFields]);
      setlayout([...newLayout]);
    } else if (selectForm === 'existing') {
      setlayout([...existingLayout]);
      let __fields =
        fields &&
        fields.map((_field: any) => {
          if (_field?.compProps?.id === 'website') {
            return {
              ..._field,
              compProps: {
                ..._field.compProps,
                required: true,
              },
            };
          } else return _field;
        });
      setFormFields([...__fields, ...existingFields]);
    }
  }, [selectForm]);

  useEffect(() => {
    console.log(
      'tempresponse from parish :: 1',
      temp,
      activeStep,
      initialData,
      initialData['subsidiaries'],
      initialData['subsidiaries'] && initialData?.subsidiaries[0]?.parish
    );
    if (activeStep === 1 && temp === 1) {
      if (initialData['parish'] && initialData['operatingParish']) {
        _onChangeinitial(
          'parish',
          initialData['parish'],
          'operatingParish',
          initialData['operatingParish']
        );
        console.log('asdgjkafds', initialData['operatingCity']);
      } else {
        initialData['parish'] &&
          _onChangeinitial('parish', initialData['parish']);
        initialData['operatingParish'] &&
          _onChangeinitial('operatingParish', initialData['operatingParish']);
      }
    }
    // activeStep===1 && temp===2 && _allchanges(initialData);
    //     if(activeStep===1 && temp===2 && initialData['subsidiaries'] && initialData['subsidiaries'][0]['parish'] && initialData['branches'] && initialData['branches'][0]['parish']){
    //     _ondoubleChange('dynamicField',{
    //       id: "subsidiaries",
    //       subId: "parish",
    //       payload: initialData['subsidiaries'][0]['parish'],
    //   },'dynamicField',{
    //     id: "branches",
    //     subId: "parish",
    //     payload: initialData['branches'][0]['parish'],
    // })}
    // else if(activeStep===1 && temp===2 && initialData['subsidiaries'] && initialData['subsidiaries'][0]['parish']){
    //   _onChange('dynamicField',{
    //     id: "subsidiaries",
    //     subId: "parish",
    //     payload: initialData['subsidiaries'][0]['parish'],
    // })
    // }
    // else if(activeStep===1 && temp===2 && initialData['branches'] && initialData['branches'][0]['parish']){
    //   _onChange('dynamicField',{
    //     id: "branches",
    //     subId: "parish",
    //     payload: initialData['branches'][0]['parish'],
    // })
    // }
  }, [temp, activeStep]);
  const _renderHeader = (isPreview: boolean) => {
    return (
      <div className="mt-2">
        {/* {isPreview && (
          <h3 className="text-uppercase text-center">{previewLabel}</h3>
        )} */}
        <h4 className="text-center">{isPreview ? previewLabel : label}</h4>
      </div>
    );
  };
  const getProgressSteps = () => {
    return formData.progressBarSteps!.map((step, key: number) => {
      return step;
    });
  };

  console.log('kh->', initialData);

  const getWidgetData = () => {
    const formData: any[] = [];
    const fileData: any[] = [];
    const specialData: any[] = [];
    const specialNavItems: any[] = [];
    let _widgetData;
    const special = {
      directors: 'Director',
      subsidiaries: 'Subsidiary',
      branches: 'Branch',
    };
    console.log('initialdatainorgprofile->', initialData);
    if (initialData && Object.entries(initialData)?.length > 0) {
      formFields?.forEach((item) => {
        if (
          special[item?.compProps?.id] &&
          Array.isArray(initialData[item?.compProps?.id])
        ) {
          specialNavItems.push({
            key: item?.compProps?.id,
            title: toCamelCase(item?.compProps?.id),
            link: `/${item?.compProps?.id}`,
            type: 'navbar',
          });

          const ele = formFields?.filter(
            (_item: any) => _item?.compProps?.id === item?.compProps?.id
          )?.[0];
          const reqEle = ele?.compProps?.attributeForm?.fields;
          const totalData: any[] = [];
          initialData[item?.compProps?.id]?.forEach((val, key) => {
            const currData: any[] = [];
            item?.compProps?.attributeForm?.fields?.forEach((_item) => {
              if (
                _item?.compProps?.label &&
                initialData[item?.compProps?.id]?.[key]?.[_item?.compProps?.id]
              ) {
                currData.push({
                  title: _item?.compProps?.label,
                  subTitle:
                    initialData[item?.compProps?.id]?.[key]?.[
                      _item?.compProps?.id
                    ],
                  icon: 'https://i.ibb.co/ydYfzdV/check-mark-1.png',
                });
              }
            });
            totalData.push(currData);
          });

          specialData.push({
            type: 'accordion',
            key: item?.compProps?.id,
            data: totalData?.map((data, key: number) => {
              return {
                type: 'multi-col-list',
                title: `${special[item?.compProps?.id]} ${key + 1}`,
                numberOfColumns: '3',
                data: data,
              };
            }),
          });

          console.log('special->', specialData);
        } else if (Array.isArray(initialData[item?.compProps?.id])) {
          const ele = formFields?.filter(
            (_item: any) => _item?.compProps?.id === item?.compProps?.id
          )?.[0];
          if (ele) {
            if (initialData[item?.compProps?.id][0]?.type === 'image/png') {
              fileData.push({
                type: 'img',
                src:
                  initialData[item?.compProps?.id][0]?.base64 ??
                  initialData[item?.compProps?.id][0]?.src,
                meta: [
                  initialData[item?.compProps?.id][0]?.name,
                  initialData[item?.compProps?.id][0]?.size,
                ],
                title: [ele?.compProps?.label],
              });
            } else if (
              initialData[item?.compProps?.id][0]?.type === 'application/pdf'
            ) {
              fileData.push({
                type: 'pdf',
                src:
                  initialData[item?.compProps?.id][0]?.base64 ??
                  initialData[item?.compProps?.id][0]?.src,
                meta: [
                  initialData[item?.compProps?.id][0]?.name,
                  initialData[item?.compProps?.id][0]?.size,
                ],
                title: [ele?.compProps?.label],
              });
            } else if (
              initialData[item?.compProps?.id][0]?.type === 'image/jpeg'
            ) {
              fileData.push({
                type: 'img',
                src:
                  initialData[item?.compProps?.id][0]?.base64 ??
                  initialData[item?.compProps?.id][0]?.src,
                meta: [
                  initialData[item?.compProps?.id][0]?.name,
                  initialData[item?.compProps?.id][0]?.size,
                ],
                title: [ele?.compProps?.label],
              });
            }
          }
        } else {
          const ele = formFields?.filter(
            (_item: any) => _item?.compProps?.id === item?.compProps?.id
          )?.[0];
          if (
            ele &&
            !item?.compProps?.id?.startsWith('is') &&
            initialData[item?.compProps?.id]
          ) {
            formData.push({
              title: ele?.compProps?.label,
              subTitle: initialData[item?.compProps?.id]?.includes(':')
                ? initialData[item?.compProps?.id]?.split(':')?.[1]
                : initialData[item?.compProps?.id],
              icon: 'https://i.ibb.co/ydYfzdV/check-mark-1.png',
            });
          }
        }
      });
      const widgetData = {
        profileData: {
          activeKey: 'orgDetails',
          submitBtnText: 'Submit',
          checkBoxText:
            'I certify that I have carefully read the General Information and Application Guidelines sections on the Ministry of Labour and Social Security`s Work Permit Website and I understand all requirements and restrictions for making this application.',
          navItems: [
            {
              key: 'orgDetails',
              title: 'Organization Details',
              link: '/personal',
              type: 'navbar',
            },
            ...specialNavItems,
            ...renderIf(fileData, {
              key: 'documents',
              title: 'Documents',
              link: '/documents',
              type: 'navbar',
            }),
          ],
        },
        itemSpecData: [
          {
            type: 'accordion',
            key: 'orgDetails',
            data: [
              {
                type: 'multi-col-list',
                title: 'Organization Details',
                numberOfColumns: '3',
                data: formData,
              },
            ],
          },
          ...specialData,
          {
            type: 'media-carousel',
            key: 'documents',
            data: fileData,
          },
        ],
        paginationProps: {
          totalCount: 2,
          totalPages: 1,
          forcePage: 0,
          totalItems: 2,
        },
      };
      _widgetData = widgetData;
      console.log('widget->', _widgetData);
      return widgetData;
    }
    return {};
  };

  console.log('lio->', initialData);

  const changeTouchStatus = (data: any, key: string) => {
    // onNextClick && onNextClick(data);
    // setInitialData && setInitialData(data);
    console.log('kkk', key);
    setDynamicKey(key);
    _setTouchedStatus({ ..._touchedStatus, [temp]: true });
    setStepHasError({ ...stepHasError, ...prevsteperr });
    if (key == 'first') {
      // if(temp==3)
      // setStepHasError({3:false,...stepHasError})

      setTemp(1);
    } else if (key == 'second') {
      // if(temp==3)
      // setStepHasError({3:false,...stepHasError,})
      // else
      // setStepHasError({1:false,...stepHasError,})
      setTemp(2);
    } else if (key == 'third') {
      // setStepHasError({1:false,2:false,...stepHasError,})
      setTemp(3);
    }
    // setTouched({ ...touched, [`${activeStep}-${dynamicKey}`]: true });

    // console.log('pok->', tempKey, dynamicKey);
    // settempKey(key);
  };
  const renderIf = (data: any, ele: any) => {
    console.log(data, 'lo->');
    if (Array.isArray(data) && data.length > 0) {
      return [ele];
    }
    return [];
  };
  const _renderSubmitButton = () => {
    return (
      <Row
        className="mt-3"
        style={{ justifyContent: 'space-around', display: 'flex' }}
      >
        {/* <Button
          variant="secondary"
          type="button"
          className="mt-2 animate-up-2"
          style={{
            width: '25%',
            borderRadius: '0px',
            height: '40px',
            fontWeight: 'bold',
          }}
          disabled
        >
          {'Save for later'}
        </Button> */}
        <div className="m-auto" style={{ width: 'fit-content' }}>
          <Button
            variant="secondary"
            type="submit"
            className="mt-2 animate-up-2"
            style={{
              borderRadius: '10px',
              height: '40px',
              fontWeight: 'bold',
              background: 'linear-gradient(to bottom right,#2f78d1,#104382)',
            }}
          >
            {activeStep <= 1 ? 'Next' : 'Submit'}
          </Button>
        </div>
      </Row>
    );
  };

  console.log(activeStep);
  const profileData = {
    isLargeTitle: true,
    navItems: Object.entries(newLayout2[0]).map((_item: any, key: any) => {
      console.log('ITEM:::', _item);
      console.log('HAHAHA', _item[0], key);
      return {
        key: _item[0],
        touched: false,
        // title: `${stepHasError[`${activeStep}-${_item[0]}`]} ${_item[1]?.label}`,
        title: (
          <>
            {stepHasError &&
              (stepHasError[key + 1 + ''] === false ? (
                <S.Img src={errorIcon} />
              ) : stepHasError[key + 1 + ''] === true ? (
                <S.Img src={successIcon} />
              ) : (
                <></>
              ))}
            {_item[1]?.label}
          </>
        ),
        link: `/${_item[0]}`,
        type: 'navbar',
      };
    }),
  };

  const _getFormatedFields = (fieldz: any[], id: string, response: any) => {
    console.log('0007 inside function', fieldz, id, response);
    let _res: any[] = [];
    _res =
      fieldz &&
      Array.isArray(fieldz) &&
      fieldz.length > 0 &&
      fieldz.map((item: any, index: number) => {
        if (id === 'parish' && item?.compProps?.id === 'city') {
          return {
            ...item,
            compProps: {
              ...item?.compProps,
              options: response?.cities,
            },
          };
        } else {
          return { ...item };
        }
      });
    console.log(`response from parish :: #3 0007`, _res);
    return _res;
  };
  const _deletemanagerial = async (id: any, payload1: any) => {
    // let payload=payload1;
    if (id === 'subsidiaries' || id === 'branches' || id === 'directors') {
      // payload={}

      console.log(`response from subsiii111`, id, payload1);
      await getSrv().agent.createProfile({ [id]: [payload1], documents: [] });
      // const res=await getSrv().agent.createProfile({subsidiaries : [...payload1]});
      console.log(`response from subsiii222`, id, payload1, res);
    }
  };
  const cityCall = async (id: any, payload: any) => {
    const res = getcity(payload);
    return res;
  };
  const _onChangeinitial = async (
    id: any,
    payload: any,
    id2?: any,
    payload2?: any
  ) => {
    if (id && id2) {
      console.log('caeinside2res', payload, payload2);
      const res1 = getcity(payload);
      const res2 = getcity(payload2);
      if (res1 && res2) {
        let _fields: any = fields.map((item: any, index: number) => {
          if (id === 'parish' && item?.compProps?.id === 'city') {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: res1?.cities,
              },
            };
          } else if (
            id2 === 'operatingParish' &&
            item?.compProps?.id === 'operatingCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: res2?.cities,
              },
            };
          } else {
            return {
              ...item,
            };
          }
        });
        if (selectForm === 'new') {
          setFormFields([..._fields, ...newFields]);
          // setlayout([...newLayout]);
        } else if (selectForm === 'existing') {
          // setlayout([...existingLayout]);
          let __fields =
            _fields &&
            _fields.map((_field: any) => {
              if (_field?.compProps?.id === 'website') {
                return {
                  ..._field,
                  compProps: {
                    ..._field.compProps,
                    required: true,
                  },
                };
              } else return _field;
            });
          setFormFields([...__fields, ...existingFields]);
        }
      }
      // console.log(`response from parish :: 1jram`, id, payload, formFields);
    } else if (id === 'parish' || id === 'operatingParish') {
      //onParishChange && onParishChange({ ...initialData, [id]: payload });
      const _response = getcity(payload);
      console.log(`response from parish ::`, _response);
      if (_response) {
        let _fields: any = fields.map((item: any, index: number) => {
          if (id === 'parish' && item?.compProps?.id === 'city') {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'operatingParish' &&
            item?.compProps?.id === 'operatingCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else {
            return {
              ...item,
            };
          }
        });
        if (selectForm === 'new') {
          setFormFields([..._fields, ...newFields]);
          // setlayout([...newLayout]);
        } else if (selectForm === 'existing') {
          // setlayout([...existingLayout]);
          let __fields =
            _fields &&
            _fields.map((_field: any) => {
              if (_field?.compProps?.id === 'website') {
                return {
                  ..._field,
                  compProps: {
                    ..._field.compProps,
                    required: true,
                  },
                };
              } else return _field;
            });
          setFormFields([...__fields, ...existingFields]);
        }
        // setFormFields(_fields);
      }
    }
  };

  const _onChange = async (id: any, payload: any) => {
    console.log(`response from parish :: 1jram`, id, payload, formFields);
    if (id === 'dynamicField' && payload?.subId === 'parish') {
      console.log(`response from parish :: #5`, id, payload, formFields);
      const _response = getcity(payload?.payload);
      console.log(`response from parish ::`, _response);
      if (_response) {
        let _fields: any = formFields.map((item: any, index: number) => {
          if (item?.compProps?.id === payload?.id) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                attributeForm: {
                  ...item?.compProps?.attributeForm,
                  fields: _getFormatedFields(
                    item?.compProps?.attributeForm?.fields,
                    payload?.subId,
                    _response
                  ),
                },
              },
            };
          } else {
            return { ...item };
          }
        });
        console.log('ekjdadakjsds', _fields);
        setFormFields(_fields);
      }
    } else if (id === 'parish' || id === 'operatingParish') {
      //onParishChange && onParishChange({ ...initialData, [id]: payload });
      const _response = getcity(payload);
      console.log(`response from parish ::`, _response);
      if (_response) {
        let _fields: any = formFields.map((item: any, index: number) => {
          if (id === 'parish' && item?.compProps?.id === 'city') {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'operatingParish' &&
            item?.compProps?.id === 'operatingCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else {
            return {
              ...item,
            };
          }
        });

        setFormFields(_fields);
      }
    }
  };
  const settheInititalData = (payload1: any) => {
    // setInitialData(payload);
    let payload: any = payload1;
    let reldocss = (payload?.type && relatedDocuments?.[payload?.type]) || [];
    console.log('relateddoccs-->', payload?.type, reldocss);
    let docstobeadded: any[] = [];
    Object.entries(availDocuments).forEach((ele) => {
      if (
        payload[ele[0]] &&
        Array.isArray(payload[ele[0]]) &&
        payload[ele[0]].length > 0
      ) {
        if (reldocss.includes(ele[1])) {
          docstobeadded.push(payload[ele[0]]);
        } else {
          payload[ele[0]] = null;
        }
        console.log('contained docs->', ele[1], payload[ele[0]]);
      }
    });
    console.log('expectedresult->', { ...payload });
    setInitialData({ ...payload });
  };
  const _renderBody = () => {
    console.log(layout, confirmField);
    if (activeStep === 2) {
      let _fields: any = [];

      _fields = formFields.map((_field: any) => {
        if (_field?.compProps?.id === 'confirmDetails') {
          return _field;
        }

        return {
          ..._field,
          compProps: { ..._field.compProps, disabled: true, readOnly: true },
        };
      });

      console.log(`bla`, _fields, layout);

      return (
        <>
          {_renderHeader(true)}
          {/* <div style={{ justifyContent: 'center', display: 'flex' }}>
            <div style={{ width: '60%' }}>
              <TweetyWidget
                labelColor={'#104382'}
                fields={_fields}
                key={2}
                initialData={initialData}
                layout={[...layout, confirmField]}
                dynamicLayout={dynamicLayout}
                validatorConfig={validatorConfig}
                onFormSubmit={(payload: any) => {
                  setActiveStep(activeStep + 1);
                  console.log(payload, 'hi->');
                  onAcknowledgement &&
                    onAcknowledgement({
                      ...payload,
                      isNewOne: selectForm === 'new',
                    });
                }}
                renderSubmitButton={_renderSubmitButton}
                submitButtonLabel={'Submit'}
              />
            </div>
          </div> */}
          {/* @ts-ignore */}
          <ItemSpecVenusWidget
            {...getWidgetData()}
            onListClick={(item: any) => console.log(`item clicked`, item)}
            onPageChange={(event: any) => console.log(`page change`, event)}
            onSubmit={() => {
              setActiveStep(activeStep + 1);
              console.log(initialData, 'hi->');
              onAcknowledgement &&
                onAcknowledgement({
                  ...initialData,
                  isNewOne: selectForm === 'new',
                });
            }}
            onActionClick={(key, listId) =>
              console.log(`on action click`, key, listId)
            }
            // onItemClick={(itemId: string) => window.alert(itemId)}
          />
        </>
      );
    }
    if (activeStep === 0) {
      console.log(selectFormFields, selectFormLayout, 'hib->');
      return (
        <>
          <div
            style={{ justifyContent: 'center', display: 'flex' }}
            className="bg-white rounded mt-3 tweety-form-shadow"
          >
            <div style={{ width: '60%', margin: 'auto' }}>
              <TweetyWidget
                labelColor={'#104382'}
                key={0}
                fields={selectFormFields}
                validatorConfig={selectvalidatorConfig}
                layout={selectFormLayout}
                initialData={selectForm ? { companyType: selectForm } : {}}
                onFormSubmit={(payload: any) => {
                  console.log('hiiihello', payload);
                  setselectForm(payload?.['companyType']);
                  setActiveStep(activeStep + 1);
                }}
                renderSubmitButton={_renderSubmitButton}
                submitButtonLabel={'Next'}
              />
            </div>
            <RightContainer
              rightBlockContent={rightBlockContent?.selectCountry}
            />
          </div>
        </>
      );
    }
    console.log(layout, formFields, 'bla');
    if (activeStep === 1 && layout?.length > 0) {
      // console.log("jraminit",initialData);
      return (
        <>
          {_renderHeader(false)}
          <FontSlider fontScale={fontScale} updateFontScale={updateFontScale} />
          <div style={{ justifyContent: 'center', display: 'flex' }}>
            <div style={{ width: '60%' }}>
              <div className="bg-white rounded tweety-form-shadow">
                <ChannelPage
                  {...profileData}
                  fontScale={fontScale}
                  activeKey={dynamicKey}
                  onNavItemClick={(key: string) => {
                    changeTouchStatus(initialData, key);
                  }}
                  isNoProfileExist={true}
                />
                <TweetyWidget
                  labelColor={'#104382'}
                  key={`${activeStep}${selectForm}dy${dynamicKey}`}
                  fields={formFields.map((field) => {
                    switch (field.compProps.id) {
                      case 'trn':
                        return {
                          ...field,
                          compProps: {
                            ...field.compProps,
                            disabled: trnEnable,
                            readOnly: trnEnable,
                          },
                        };
                      default:
                        return field;
                    }
                  })}
                  fontScale={fontScale}
                  initialData={initialData}
                  setInitData={(val) => setInitialData(val)}
                  //setParish={(dat) => setParish(dat)}
                  prevsteperr={prevsteperr}
                  setPrevStepErr={setPrevStepErr}
                  _setTouchedStatus={_setTouchedStatus}
                  _touchedStatus={_touchedStatus}
                  _deletemanagerial={_deletemanagerial}
                  dynamicKey={dynamicKey}
                  layout={newLayout2[0]?.[dynamicKey]?.data}
                  dynamicLayout={dynamicLayout}
                  cityCall={cityCall}
                  onChange={(id, payload) => {
                    if (id === 'isAddBranch' && payload === 'no') {
                      console.log('1st came check***');
                      setInitialData({
                        ...initialData,
                        [id]: payload,
                        branches: null,
                      });
                    } else if (id === 'isAddSubsidiary' && payload === 'no') {
                      console.log('2nd came check***');

                      setInitialData({
                        ...initialData,
                        [id]: payload,
                        subsidiaries: null,
                      });
                    } else if (id === 'isAddDirector' && payload === 'no') {
                      console.log('3rd came check***');

                      setInitialData({
                        ...initialData,
                        [id]: payload,
                        directors: null,
                      });
                    } else setInitialData({ ...initialData, [id]: payload });

                    console.log(`onChange in index: `, id, payload);
                    _onChange(id, payload);
                  }}
                  temp={temp}
                  tempKey={tempKey}
                  setStepHasError={setStepHasError}
                  stepHasError={stepHasError}
                  onFormSubmit={(payload: any) => {
                    // setTouched(true);
                    setStepHasError({ ...stepHasError, ...prevsteperr });
                    if (temp >= 3) {
                      if (stepHasError[1] && stepHasError[2]) {
                        onNextClick &&
                          onNextClick({
                            ...initialData,
                            ...payload,
                            isNewOne: selectForm === 'new',
                          });
                        console.log('hiiihello1stifcase', payload);
                        // setInitialData({ ...initialData, ...payload });
                        settheInititalData({ ...initialData, ...payload });
                        console.log('hi->');
                        setActiveStep(activeStep + 1);
                      }
                    } else {
                      console.log('hiiihello2ndifcase', payload);
                      onNextClick &&
                        onNextClick({
                          ...initialData,
                          ...payload,
                          isNewOne: selectForm === 'new',
                        });
                      // setInitialData({ ...initialData, ...payload });
                      if (temp == 1) {
                        setDynamicKey('second'), setTemp(2);
                      } else if (temp == 2) {
                        setDynamicKey('third'), setTemp(3);
                      }
                      // setTemp(temp=>temp+1);
                    }
                    window.scrollTo(0, 0);
                  }}
                  renderSubmitButton={_renderSubmitButton}
                  validatorConfig={validatorConfig}
                  submitButtonLabel={'Next'}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
  };
  return (
    <>
      <ProgressBar
        onActiveStepChange={onActiveStepChange}
        activeStep={activeStep}
        totalSteps={2}
        onCloseClick={onGoBack}
        progressBarSteps={getProgressSteps()}
      />
      {_renderBody()}
    </>
  );
};

FormCompp.defaultProps = {
  field: {
    label: 'Select Company Incorporation Status',
    options: [
      {
        label: 'Select..',
        value: '',
      },
      {
        label: 'New',
        value: 'new',
      },
      {
        label: 'Existing',
        value: 'existing',
      },
    ],
  },
};
